<template>
  <div style="width:100%;">
    <el-row :gutter="20" class="echart-all">
      <el-col :span="16" style="padding-left:0">
        <div class="all-left">
          <div class="left-title">{{$t('DriverAnalysis.violationTrend')}}</div>
          <div v-if="isLine" v-loading="lineLoading">
            <linegraph
              :id="'linegraph2'"
              :data="optionLine"
              style="height: 300px"
            ></linegraph>
          </div>
          <div
            v-else
            style="
              color: #868686;
              font-size: 16px;
              text-align: center;
              line-height: 300px;
            "
          >
            {{$t('common.noData')}}
          </div>
        </div>
      </el-col>
      <el-col :span="8" style="padding-right:0">
        <div class="all-left">
          <div class="left-title">{{$t('DriverAnalysis.violationProp')}}</div>
          <div v-loading="pieLoading">
            <linegraph
              v-loading="pieLoading"
              :id="'piegraph'"
              :data="optionPie"
              style="height: 300px"
            ></linegraph>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="dataTable">
      <div class="table-title">{{$t('DriverAnalysis.violationDetail')}}</div>
      <div class="rightAll-btn" style="float: right">
        <el-button v-if="isPrimaryKey('DRIVERANALYSIS_DRIVERVIOLATION_MONTH_DOWN')" type="text" @click="downCar">{{$t('common.btn.download')}}</el-button>
      </div>
      <i-table
        :list="list"
        ref="carTable"
        @handleSelectionChange="handleSelectionChange"
        :options="option"
        :columns="columns"
        :operates="operates"
      ></i-table>
      <IPagination ref="page" @PageFun="changeSize"></IPagination>
    </div>
  </div>
</template>

<script>
import MonthTime from "./MonthTime";
export default MonthTime;
</script>

<style lang="less" scoped>
@import "../../../../../assets/styles/Style.less";
</style>
